// extracted by mini-css-extract-plugin
module.exports = {"appBar":"app-bar-module__appBar___2BN7f","logo":"app-bar-module__logo___3vJVq","title":"app-bar-module__title___3NLdd"};